import * as React from 'react';
import { Text, Modal, MessageBoxFunctionalLayout } from 'wix-style-react';
import { translate, InjectedTranslateProps } from 'react-i18next';
import { DataHooks } from '@src/constants/data-hooks';
import { withBIModalEvents, ModalProps } from '@src/components/with-bi-modal-events/with-bi-modal-events';
import { PopupType } from '@src/context/actions/bi';

type Props = ModalProps & InjectedTranslateProps & { isOpen: boolean };
const DisableApprovalComponent = translate()(({ t, isOpen, onClose, onCancel, onOk }: Props) => (
  <Modal dataHook={DataHooks.SaveDisableModal} isOpen={isOpen} onRequestClose={onClose} shouldCloseOnOverlayClick>
    <MessageBoxFunctionalLayout
      dataHook={DataHooks.SaveDisablePrompt}
      confirmText={t('privacy-policy.disable-approval.save')}
      onOk={onOk}
      cancelText={t('privacy-policy.disable-approval.cancel')}
      onCancel={onCancel}
      onClose={onClose}
      title={t('privacy-policy.disable-approval.title')}
      width="600px"
    >
      <Text>{t('privacy-policy.disable-approval.message')}</Text>
    </MessageBoxFunctionalLayout>
  </Modal>
));

export const DisableApproval = withBIModalEvents(PopupType.DisableApproval)(DisableApprovalComponent);
